import { render, staticRenderFns } from "./gestation-period-container.vue?vue&type=template&id=dd360a04&scoped=true&lang=pug"
import script from "./gestation-period-container.js?vue&type=script&lang=js&external"
export * from "./gestation-period-container.js?vue&type=script&lang=js&external"
import style0 from "./gestation-period-container.vue?vue&type=style&index=0&id=dd360a04&prod&lang=scss&scoped=true"
import style1 from "./gestation-period-container.vue?vue&type=style&index=1&id=dd360a04&prod&style=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd360a04",
  null
  
)

export default component.exports